import { computed, inject, Injectable } from "@angular/core";
import { CounterStore } from "./counter-store.service";
import { FeedbackService } from "src/app/apiModule";
import { ToastController } from "@ionic/angular/standalone";
import { QuangAuthService } from "quang/auth";
import { toObservable, takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { distinctUntilChanged } from "rxjs";
import { Roles } from "./Roles";

@Injectable({
    providedIn: 'root'
})
export class CounterController {
    private readonly counterStore = inject(CounterStore)
    private readonly feedbackService = inject(FeedbackService)
    private readonly toastController = inject(ToastController)
    private readonly authService = inject(QuangAuthService)

    readonly unreadCount = this.counterStore.counterState.unreadCount
    readonly unreadMessagesCount = this.counterStore.counterState.unreadMessagesCount
    readonly unreadClosedMessagesCount = this.counterStore.counterState.unreadClosedMessagesCount

    readonly isAdministrator = computed<boolean>(() => this.authService.roles()?.has(Roles.ADMINISTRATOR.toString()))
    readonly isManagerOrServiceDesk = computed<boolean>(() => this.authService.roles()?.has(Roles.MANAGER.toString()) || this.isServiceDeskOrAdmin())
    readonly isServiceDeskOrAdmin = computed<boolean>(() => this.authService.roles()?.has(Roles.SERVICE_DESK.toString()) || this.isAdministrator())
    readonly isManagerOrReporter = computed<boolean>(() => this.isManagerOrServiceDesk() || this.authService.roles()?.has(Roles.REPORTER.toString()))

    private readonly onChangeRoles$ = toObservable(this.authService.roles).pipe(distinctUntilChanged(), takeUntilDestroyed()).subscribe((_roles) => {
        console.log(_roles)
        if (this.isManagerOrReporter()) {
            this.retrieveUnreadMessagesCount()
            this.retrieveUnreadClosedMessagesCount()
        }
        if (this.isManagerOrServiceDesk()) {
            this.retrieveUnreadCount()
        }
    })

    retrieveUnreadCount() {
        this.feedbackService.countUnread().subscribe({
            next: (res) => {
                this.counterStore.setUnreadCount(res?.count ?? 0)
            },
            error: (error) => {
                this.showToastError(error.error)
            }
        })
    }

    retrieveUnreadMessagesCount() {
        this.feedbackService.countUnreadMessages().subscribe({
            next: (res) => {
                this.counterStore.setUnreadMessagesCount(res?.count ?? 0)
            },
            error: (error) => {
                this.showToastError(error.error)
            }
        })
    }

    retrieveUnreadClosedMessagesCount() {
        this.feedbackService.countArchivedUnreadMessages().subscribe({
            next: (res) => {
                this.counterStore.setUnreadClosedMessagesCount(res?.count ?? 0)
                // this.notificationCounter.updateClosedUnreadMessagesCounter(res?.count ?? 0)
            },
            error: (error) => {
                this.showToastError(error.error)
            }
        })
    }

  private showToastError(error: Error) {
    this.toastController
      .create({
        message: error.message,
        duration: 4000,
        color: "danger",
        position: "bottom",
      })
      .then((t) => t.present());
  }
}